import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ValidationCodeVm } from 'src/app/view-model/validation-code/validation-code.vm';

interface DataSelectMethod {
  customerRef?: string;
  byCall?: string | boolean;
  bySMS?: string | boolean;
  byEmail?: string | boolean;
  byWhatsApp?: string | boolean;
}

@Component({
  selector: 'app-select-method-code',
  templateUrl: './select-method-code.component.html',
  styleUrls: ['./select-method-code.component.scss']
})
export class SelectMethodCodeComponent implements OnInit {
  public codeMethod: string;
  @Input() sms: boolean;
  @Input() call: boolean;
  @Input() email: boolean;
  @Input() wapp: boolean = true;
  @Input() customer: any;
  @Input() isSingUp: boolean = false;
  @Output() closeSelect: EventEmitter<any> = new EventEmitter();
  @Output() newCode: EventEmitter<any> = new EventEmitter();
  @Output() sendMethod: EventEmitter<any> = new EventEmitter();

  public phoneData;
  public emailData;
  public isDisabled: boolean;

  public data: DataSelectMethod = {
    customerRef: ''
  }

  constructor(
    private vm : ValidationCodeVm
  ) {
    this.codeMethod = '';
    this.isDisabled = true;
  }

  ngOnInit() {
    this.getInitialData();
  }

  getInitialData(){
    this.phoneData = (!this.isSingUp) ? this.customer.list[0].data : this.fadeNumber( this.customer );
    this.emailData = (!this.isSingUp) ? this.customer.list[1].data : '';

    if(!this.isSingUp){
      this.data.customerRef = this.customer.idCustomer;
    }
  }

  fadeNumber( cellphone ){
    let start = cellphone.slice(0, 5);
    let end = cellphone.slice(-3);
    return `${start}****${end}`;
  }

  sendOption(){
    if( Object.keys(this.data).length > 1 && !this.isSingUp ){
      this.data['byCall'] = (this.data['byCall'] === 'call') ? true : false;
      this.data['bySMS'] = (this.data['bySMS'] === 'sms') ? true : false;
      this.data['byEmail'] = (this.data['byEmail'] === 'email') ? true : false;
      this.data['byWhatsApp'] = (this.data['byWhatsApp'] === 'wapp') ? true : false;
      this.handleSendMethod();
      this.vm.selectMethoCode(this.data).subscribe( res => {
        if( res?.code === 'OK' ){
          this.closeSelect.emit({
            close: true
          });
        }
      });
    }

    if( Object.keys(this.data).length > 0 && this.isSingUp ){
      this.data['byCall'] = (this.data['byCall'] === 'call' || '');
      this.data['bySMS'] = this.data['bySMS'] === 'sms';
      this.data['byEmail'] = this.data['byEmail'] === 'email';
      this.data['byWhatsApp'] = (this.data['byWhatsApp'] === 'wapp' || '');

      this.vm.validateSmsToken(this.customer, this.data['byCall'], this.data['byWhatsApp']).subscribe( res => {
        if( res?.code === 'OK' ){
          this.closeSelect.emit({
            close: true
          });
          this.newCode.emit( { code: res.tokenFarmatodo } );
        }
      });
    }

    this.clearData();
  }

  handleSendMethod() {
    this.sendMethod.emit(this.data);
  }

  chageOption( event ){
    this.isDisabled = false;
  }

  clearData(): void {
    this.data = {
      ...this.data,
      byCall: '',
      bySMS: '',
      byEmail: '',
      byWhatsApp: '',
    };
  }

}
